/**
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 12-Jun-2024
 */

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { doProfiling } from 'Store/actions/userProfiling'
import { Routes, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'

const WithProfilingCheck = ({ children, doProfiling, logged }) => {
  const [computationEnded, setComputationEnded] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if (children.length > 0) {
      const mapperThatExcludesGetStatus = children.reduce((acc, obj) => {
        const { path, excludeProfiling } = obj.props

        if (excludeProfiling) {
          const trimmedPath = path.length > 2 ? path.slice(0, -2) : path.slice(0, -1) // e.g '/login-handler/*' -> '/login-handler' or '/*' -> '/'
          acc[trimmedPath] = true
        }
        return acc
      }, {})

      const hasMatchingKey = Object.entries(mapperThatExcludesGetStatus).some(([key]) => location.pathname.includes(key))
      if (!hasMatchingKey) {
        doProfiling()
      }

      setComputationEnded(true)
    }
  }, [logged])

  return (
    computationEnded && <Routes>{children}</Routes>
  )
}

WithProfilingCheck.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  doProfiling: PropTypes.func.isRequired,
  logged: PropTypes.bool
}

WithProfilingCheck.defaultProps = {
  logged: false
}

const mapDispatchToProps = {
  doProfiling
}

export default connect(null, mapDispatchToProps)(WithProfilingCheck)
